import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { SysAdminService } from "../../../services/sysadmin.service";
import { SchoolsToChangeModel } from "../SchoolsToChangeModel";

@Component({
	selector: "app-user-group-add-school",
	templateUrl: "./user-group-add-school.component.html",
	styleUrls: ["./user-group-add-school.component.css"],
})
export class UserGroupAddSchoolComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.AllowMultipleSchools = this.dialogConfig.data.AllowMultipleSchools;
		this.UserGroupID = this.dialogConfig.data.UserGroupID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadSchoolList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	//Data from Parent
	UserLevelID: number = 3;
	AllowMultipleSchools: boolean = false;
	UserGroupID: any;
	SchoolID: any = 0;

	//Table Data
	lstSchools: any = [];
	SelectedSchools: any = [];
	OriginalSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	errorMessage: string = "";

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolList() {
		this.loading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchools = response;
				this.SelectedSchools = [];

				this.UpdateSelected();

				this.loading = false;
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedSchools = this.dialogConfig.data.SelectedSchools;
		this.OriginalSchools = this.dialogConfig.data.SelectedSchools;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		if (this.UserLevelID == 3 && this.AllowMultipleSchools == false && this.SelectedSchools.length > 1) {
			this.errorMessage = "School Level Groups can only be assigned to one school";
			return;
		}

		//Get rid of containers that are already attached to the User Group
		var SchoolsToAdd = this.SelectedSchools.filter((cont) => this.OriginalSchools.indexOf(cont) == -1);

		//Create list of strings
		var lstSchoolID: number[] = [];

		for (var i = 0; i < SchoolsToAdd.length; i++) {
			var next = Number(SchoolsToAdd[i].SchoolID);
			lstSchoolID = [...lstSchoolID, next];
		}

		//Create Query Data
		let data: SchoolsToChangeModel = {
			UserGroupID: this.UserGroupID,
			SchoolIDs: lstSchoolID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupAddSchools(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schools were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add schools to the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
